import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import Signin from "./Signin";
import Orders from "./Orders";
import Inventory from "./Inventory";
import Subs from "./Subs";
import WarehouseEvents from "./WarehouseEvents";
import Upgrades from "./Upgrades";
import Announcements from "./Announcements";
import DocumentEmails from "./DocumentEmails";
import DraftOrder from "./DraftOrder";
import Warehouse from "./Warehouse";
import Scripts from "./Scripts";
import Tasks from "./Tasks";
import Reports from "./Reports";
import Snapshots from "./Snapshots";
import NavBar from "./NavBar";
import { getCookie } from "./helpers";

// WarehouseEvents == /warehouse
const navBarRoutes = [
  "/supplychain",
  "/inventory",
  "/subs",
  "/warehouse",
  "/upgrades",
  "/announcements",
  "/documentemails",
  "/draftorder",
  "/reports",
  "/scripts",
  "/tasks",
  "/snapshots",
];

// The floor screens are behind this too: they drive PUT /api/orders/:id, which
// advances warehouse status and dispatches Shiphawk shipments.
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getCookie("ez_t") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={`/signin?next=${encodeURIComponent(
            props.location.pathname + props.location.search
          )}`}
        />
      )
    }
  />
);

const Routes = () => {
  return (
    <div className="app">
      {navBarRoutes.includes(useLocation().pathname) && <NavBar />}
      <div className="app-container">
        <Switch>
          <Route path="/signin" component={Signin} />
          <PrivateRoute path="/supplychain" component={Orders} />
          <PrivateRoute path="/inventory" component={Inventory} />
          <PrivateRoute path="/subs" component={Subs} />
          <PrivateRoute path="/warehouse" component={WarehouseEvents} />
          <PrivateRoute path="/upgrades" component={Upgrades} />
          <PrivateRoute path="/announcements" component={Announcements} />
          <PrivateRoute path="/documentemails" component={DocumentEmails} />
          <PrivateRoute path="/draftorder" component={DraftOrder} />
          <PrivateRoute path="/scripts" component={Scripts} />
          <PrivateRoute path="/reports" component={Reports} />
          <PrivateRoute path="/snapshots" component={Snapshots} />
          <PrivateRoute path="/tasks" component={Tasks} />

          <PrivateRoute path="/3pl" component={Warehouse} />
          <PrivateRoute path="/champion" component={Warehouse} />
          <PrivateRoute path="/3pllinks" component={Warehouse} />

          <Route exact path="/">
            <Redirect to="/supplychain" />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Routes;
